import classNames from 'classnames';
import { forwardRef, memo } from 'react';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  onLoad: () => void;
}

export const CsatPreview = memo(
  forwardRef<HTMLIFrameElement, Props>((props, ref) => {
    return (
      <iframe
        ref={ref}
        src="https://messenger.dixa.io/csat-preview.html"
        frameBorder="0"
        className={classNames(styles.root, props.className)}
        onLoad={props.onLoad}
      />
    );
  }),
);

CsatPreview.displayName = 'CsatPreview';
